/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import {GuidlinesProps} from ".";
import GuidelinesSection from "./GuidelinesSection";
import YesNoButtons from "./YesNoButtons";
import buildingSvg from "assets/images/building.svg";
import dollarDocumentSvg from "assets/images/dollar-document.svg";
import buildingConstructionSvg from "assets/images/building-construction.svg";
import coastalSvg from "assets/images/coastal.svg";
import Ul from "./Ul";
import ButtonsContainer from "./ButtonsContainer";
import QuestionTitle from "./QuestionTitle";

export default function HomeGuidelines({onYes, onNo}: GuidlinesProps) {
  return (
    <div
      css={css`
        display: flex;
        gap: 5px;
        flex-direction: column;
      `}
    >
      <QuestionTitle>
        Does this risk location meet the default homeowner guidelines outlined
        below?{" "}
      </QuestionTitle>
      <GuidelinesSection title="Lines of Business" svgUrl={buildingSvg}>
        <Ul>
          <li>Standard residential properties</li>
          <li>Owner-occupied dwellings</li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="TIV Limits" svgUrl={dollarDocumentSvg}>
        <Ul>
          <li>Standard coverage limits apply</li>
          <li>Based on property valuation</li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection
        title="Construction Types"
        svgUrl={buildingConstructionSvg}
      >
        <Ul>
          <li>Standard construction materials</li>
          <li>Meets local building codes</li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="Coastal Restrictions" svgUrl={coastalSvg}>
        <Ul>
          <li>Standard coastal guidelines apply</li>
          <li>Flood zone considerations</li>
        </Ul>
      </GuidelinesSection>
      <ButtonsContainer>
        <YesNoButtons onYes={onYes} onNo={onNo} />
      </ButtonsContainer>
    </div>
  );
}
